(() => {
  const dismissedKey = 'terraWelcomePopupDismissedV1';
  const joinedKey = 'terraWelcomePopupJoinedV1';

  const storage = {
    get(key) { try { return window.localStorage.getItem(key); } catch (error) { return null; } },
    set(key, value) { try { window.localStorage.setItem(key, value); } catch (error) {} }
  };

  function init(root) {
    if (!root || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const dialog = root.querySelector('.terra-welcome-popup__dialog');
    const success = Boolean(root.querySelector('[data-terra-welcome-success]'));
    const delay = Math.max(0, Number(root.dataset.delay || 1000));
    const suppressDays = Math.max(1, Number(root.dataset.suppressDays || 14));
    let previousOverflow = '';
    let lastFocused = null;

    const shouldShow = () => {
      if (success || (window.Shopify && window.Shopify.designMode)) return true;
      if (storage.get(joinedKey)) return false;
      const dismissedAt = Number(storage.get(dismissedKey) || 0);
      return !dismissedAt || Date.now() - dismissedAt > suppressDays * 86400000;
    };

    const open = () => {
      if (!shouldShow()) return;
      lastFocused = document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      window.setTimeout(() => dialog && dialog.focus(), 30);
      if (success) storage.set(joinedKey, String(Date.now()));
    };

    const close = () => {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousOverflow;
      storage.set(success ? joinedKey : dismissedKey, String(Date.now()));
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    root.querySelectorAll('[data-terra-popup-close]').forEach(button => button.addEventListener('click', close));

    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...root.querySelectorAll('button,a,input,[tabindex]:not([tabindex="-1"])')]
        .filter(element => !element.disabled && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const copyButton = root.querySelector('[data-terra-copy-code]');
    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const codeElement = root.querySelector('[data-terra-discount-code]');
        const code = codeElement && codeElement.textContent.trim();
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          copyButton.textContent = 'Copied';
        } catch (error) {
          const range = document.createRange();
          range.selectNode(codeElement);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          copyButton.textContent = 'Selected';
        }
      });
    }

    window.setTimeout(open, success ? 80 : delay);
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-terra-welcome-popup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
